import { Button } from "../../Button";
import { Col, Row } from "react-grid-system";
import { editUnit } from "../../../api/unit/unit";
import { MoreActions } from "../../MoreActions";
import { StyledDescriptionModal } from "../../../styles/StyledModal";
import { StyledModalTextarea } from "../../../styles/StyledModalTextarea";
import { StyledUnitOverview, StyledUnitOverviewTitle } from "../../../styles/StyledUnit/StyledContent";
import { UnitTree } from "../../UnitList/UnitTree";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { useEffect, useState } from "react";
import { useUnitContext } from "../../../context/unitContext";
import Modal from "react-modal";
import ModalHeader from "../../ModalHeader/ModalHeader";
import PropTypes from "prop-types";
import SaveIcon from "../../../assets/img/icons/save.svg";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function UnitOverview({ id, edit, refetch, upperUnitId }) {
	const { axiosPrivate } = useAxiosPrivate();
	const { can } = useCurrentUser();
	const canEdit = can("manageUnit", id);
	const ctx = !edit ? useUnitContext() : { description: "" };
	const [openDropdowns, setOpenDropdowns] = useState({ description: false });

	const [description, setDescription] = useState(ctx.description ? ctx.description : "");
	const [descriptionCharactersLimit, setDescriptionCharactersLimit] = useState(1000);

	const [modalIsOpen, setIsOpen] = useState(false);
	const [text, setText] = useState(ctx.description ? ctx.description : "");

	useEffect(() => {
		Modal.setAppElement("body");
	}, []);

	const handleDataUpdate = async (id, result) => {
		await editUnit(axiosPrivate, id, result, refetch);
	};

	return (
		<>
			<StyledUnitOverview role="unit-overivew">
				<Col sm={12} lg={6}>
					<Row>
						<StyledUnitOverviewTitle>
							{canEdit && (
								<MoreActions
									type="description"
									options={[
										{
											display: true,
											click: () => {
												setIsOpen(true);
											},
											testId: "description-edit",
											name: "Edit description",
										},
									]}
									isOpen={openDropdowns}
									setIsOpen={setOpenDropdowns}
									isDisabled={false}
								/>
							)}
							<h2>Description</h2>
						</StyledUnitOverviewTitle>
					</Row>
					<Row>
						<Col>
							<p role="description-description" data-testid="description-description">
								{description !== "" ? description.substring(0, descriptionCharactersLimit) : "No description found"}
							</p>
							{description !== "" && description.split("").length > 1000 && descriptionCharactersLimit === 1000 && (
								<Button onClick={() => setDescriptionCharactersLimit(5000)} bg={false} small={true}>
									Load more
								</Button>
							)}
						</Col>
					</Row>
				</Col>
				<Col sm={12} lg={6}>
					<Row>
						<h2>Position in unit structure</h2>
					</Row>
					<UnitTree id={id} upperUnitId={upperUnitId} />
				</Col>
			</StyledUnitOverview>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => setIsOpen(false)}
				style={StyledDescriptionModal}
				appElement={document.getElementById("app")}
				role="overviewEdit-modal"
			>
				<ModalHeader onClick={() => setIsOpen(false)} data-testid="overviewEdit-modalHeader">
					Edit description
				</ModalHeader>
				<StyledModalTextarea>
					<textarea
						role="overviewEdit-textarea"
						data-testid="overviewEdit-textarea"
						onChange={(e) => {
							setText(e.target.value);
						}}
						defaultValue={text}
					></textarea>
					<div>
						<Button testid="overviewEdit-cancelButton" onClick={() => setIsOpen(false)} bg={false} small={true}>
							Cancel
						</Button>
						<Button
							icon={SaveIcon}
							testid="overviewEdit-submitButton"
							onClick={() => {
								setDescription(text);
								const result = { description: text };
								setIsOpen(false);
								handleDataUpdate(id, result);
							}}
						>
							Save changes
						</Button>
					</div>
				</StyledModalTextarea>
			</Modal>
		</>
	);
}

UnitOverview.propTypes = {
	id: PropTypes.string,
	upperUnitId: PropTypes.any,
	test: PropTypes.bool,
	status: PropTypes.object,
	edit: PropTypes.bool,
	refetch: PropTypes.func,
};

UnitOverview.defaultProps = {
	test: false,
};
